<!-- 公共项组件父组件 -->
<template>
  <div class="item-box">
    <div class="item-content">
      <!-- 头部：标题和删除 -->
      <div class="item-header">
        <div class="title-info">
          <div name="title-info">
            <span v-if="title" class="title">{{ title }}</span>
          </div>
        </div>
        <div class="header-actions">
          <span v-if="showRemove" @click="$emit('remove-item', index)" class="el-icon-close action-icon"></span>
        </div>
      </div>

      <!-- 内容部分 -->
      <slot>
        
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    showRemove: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.item-box {
  width: 100%;

  .item-content {
    list-style: none;
    background: #ffffff;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    padding: 6px 14px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      border-color: #409eff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    // 头部：标题和删除
    .item-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      padding-bottom: 4px;
      border-bottom: 1px solid #f0f0f0;

      .title-info {
        display: flex;
        align-items: center;

        .title {
          font-weight: 600;
          margin-right: 12px;
          color: #409eff;
          font-size: 12px;
        }
      }

      .header-actions {
        display: flex;
        align-items: center;
        gap: 8px;

        .action-icon {
          color: #909399;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
          padding: 4px;
          border-radius: 4px;

          &:hover {
            transform: scale(1.1);
          }
        }

        .el-icon-close:hover {
          color: #f56c6c;
          background-color: rgba(245, 108, 108, 0.1);
        }
      }
    }
  }
}
</style>